// This is an autogenerated file. Do not manually edit.
// Run `node packages/framework/owa-fluent-icons-svg/updateIcons.js` to update the icons in this package
import * as React from 'react';
import { createIconModule } from '../createIconModule';

export default createIconModule('ChevronDownFilled', props => (
    <svg {...props} viewBox="0 0 16 16">
        <path d="M3.2 5.74a.75.75 0 011.06-.04L8 9.23l3.74-3.53a.75.75 0 111.02 1.1l-4.25 4a.75.75 0 01-1.02 0l-4.25-4a.75.75 0 01-.04-1.06z" />
    </svg>
));
